module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.box_show),
      expression: "box_show"
    }],
    staticClass: "drawer-box",
    class: [_vm.box_show && 'is_open', _vm.position_set],
    style: (_vm.set_drawer_style)
  }, [_c('div', {
    staticClass: "drawer__container",
    class: _vm.body_show && 'drawer-open'
  }, [_c('div', {
    staticClass: "ni-drawer"
  }, [_c('div', {
    staticClass: "drawer-header"
  }, [_vm._t("title", [_c('span', {
    staticClass: "header-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('span', {
    staticClass: "drawer-header_btn"
  }, [_vm._t("tool"), _vm._v(" "), _c('ni-icon', {
    staticClass: "header-btn",
    attrs: {
      "icon": "#the_third_iconcuowu-copy",
      "size": "mini",
      "title": "关闭",
      "iconStyle": _vm.header_tool_icon
    },
    on: {
      "click": _vm.handle_close
    }
  })], 2)], 2), _vm._v(" "), _c('div', {
    staticClass: "drawer-body_outer"
  }, [_c('div', {
    staticClass: "drawer-body"
  }, [_vm._t("body")], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-bd962500","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ni-ui/drawer/drawer.vue
// module id = ax6F
// module chunks = 81